import { Link } from "react-router-dom";

// Programme data — sourced from Projects at Britannia Row briefing
const strands = [
  {
    id: "ft-project-space",
    key: "01",
    title: "FT Project Space",
    subtitle: "The building's main programme — group shows, performance, residencies.",
    tag: "Florence Trust",
    events: [
      {
        date: "05.06 — 07.07.26",
        title: "Art Embassy Network",
        kind: "Group exhibition",
        body:
          "A group show of international artists partnering with a collection of embassy programmes, followed by a selected group show of local artists.",
      },
      {
        date: "11.07.26",
        title: "Billy Sassi",
        kind: "Theatre — one weekend only",
        body: "A play staged inside the building over one weekend.",
      },
      {
        date: "24.07 — 01.08.26",
        title: "FT Artists in Residency — End of Year Show",
        kind: "Residency exhibition",
        body:
          "Twelve international artists showing across the ground floor, rear and top floor spaces as a culmination to the residency programme. The core of the Florence Trust programme, run since 1989 — subsidised studios, group crits, talks, visits, shows, mentoring and a publication.",
      },
      {
        date: "31.07.26",
        title: "Islington Music Festival — Live Performance",
        kind: "Music",
        body:
          "A live classical performance staged in and amongst the artworks, as part of the wider Islington Music Festival.",
      },
      {
        date: "02.08 — 20.09.26",
        title: "Padraig MaCana — Live Painting",
        kind: "Open studio · workshops",
        body:
          "Paddy takes over the ground floor project space to produce three large-scale works, while running the space as an open studio in which workshops take place and visitors meet the artist.",
      },
      {
        date: "02.10 — 25.10.26",
        title: "Building-wide Open Studios & London Art Week",
        kind: "Open studios · finale",
        body:
          "A building-wide open, with artists showing works in studios and across the gallery and project space areas — a celebration and culmination of our time at Britannia Row.",
      },
    ],
  },
  {
    id: "euca-annex",
    key: "02",
    title: "EUCA Annex",
    subtitle:
      "A sequential curatorial programme of overlapping duo exhibitions across 2026.",
    tag: "Sponsored by the Florence Trust",
    intro:
      "EUCA Annex is a site for contemporary art production and cross-disciplinary research — a platform to foster dialogues between emerging and established artists. Recently moved from a purpose-built space to a new home in Britannia Row, in partnership with The Florence Trust. The Duo Show series invites a creative dialogue between pairs of artists, an evolving process of overlapping exhibitions transforming EUCA Annex's Britannia Row space through 2026.",
    events: [
      {
        date: "20.05 — 13.06",
        title: "Duo Show 1 — Elliot Jeffries & John Timberlake",
        kind: "Exhibition",
        talk: "Artists' talk — 13 June, 2pm",
        body:
          "Elliot Jeffries (Chelsea; Royal Academy Schools) uses found technologies, objects and sculptural techniques to build installations dealing with a contemporary foreboding. John Timberlake (Whitney; Goldsmiths) works with painting, photography and drawing — landscape as a construct of time as much as space. Held in the Imperial War Museum, Royal London Hospital NHS Trust and West Collection, PA.",
      },
      {
        date: "25.06 — 18.07",
        title: "Duo Show 2 — Frederike Schweizer & Kate Squires",
        kind: "Exhibition",
        talk: "Artists' talk — 27 July, 4pm",
        body:
          "Frederike Schweizer (Vienna) makes textile-based works that hold system and gesture at once — stitching by hand, slowing the line at the threshold where system turns into touch. Kate Squires (London) works in sculpture with performance, digital media and collaborative settings; ambiguous objects communicate use and consumerism, laying slippages bare within visual and language systems.",
      },
      {
        date: "06.08 — 22.08",
        title: "Duo Show 3 — Paul McDevitt & Tommy Støckel",
        kind: "Exhibition",
        talk: "Artists' talk — 8 August, 4pm",
        body:
          "Tommy Støckel (Berlin) reworks everyday objects, spaces and found digital material into site-specific installations, sculptures, photographs, typefaces and emojis. Shown at Frankfurter Kunstverein, Nikolaj Kunsthal, CAPC Bordeaux and the Gwangju Biennale. Paul McDevitt (Berlin) works across painting, drawing, sculpture, video and performance — runs Farbvision and co-founded Infinite Greyscale.",
      },
      {
        date: "03.09 — 19.09",
        title: "Duo Show 4 — Ocean Baulcombe-Toppin & Élise Legal",
        kind: "Exhibition",
        talk: "Artists' talk — 5 September, 4pm",
        body:
          "Ocean Baulcombe-Toppin (London) is a multidisciplinary artist whose practice centres slow praxis — connectivity, temporality and memory through a lens of Afro-Caribbean diasporic identity. Élise Legal (Paris) combines found images, drawing and poetry, attentive to the way language and bodies coexist; recent residencies at Fondation Pernod Ricard and Université Paris 8.",
      },
      {
        date: "02.10 — 24.10",
        title: "Group Exhibition",
        kind: "Exhibition",
        talk: "Artists' talk — 24 October, 4pm",
        body: "Details to be confirmed in late August 2026.",
      },
    ],
  },
  {
    id: "writers-room",
    key: "03",
    title: "The Writers' Room",
    subtitle:
      "A space for those working at the intersection of fine art and literature.",
    tag: "Sponsored by the Florence Trust",
    intro:
      "The Writers' Room — a branch of independent publishing house The Wild Pansy Press (Leeds & London) — is a site for those working at the intersection of fine art and literature: art writing, memoir, auto-fiction, science fiction, fan-fiction, zine culture, sound art, broadcasting and the spoken word. A working studio reimagined as a site for publication launches, performances, screenings and symposia. All events run at the space 6–8pm — follow @wpp_writersroom on Instagram for confirmed details.",
    events: [
      {
        date: "Thu 11.06.26",
        title: "Tryhard — Magazine Launch",
        kind: "Launch",
        body: "Artist duo Tryhard launch their magazine.",
      },
      {
        date: "June 2026",
        title: "LOLAKI VIDEO CLUB — Issue 01",
        kind: "Screening series",
        body: "Femilola O'Brien-Dele's screening series opens with Issue 01.",
      },
      {
        date: "June 2026",
        title: "PEASANT! Summer Reading Group",
        kind: "Residency",
        body:
          "Esmé Hogeveen (Toronto) in residence with the PEASANT! summer reading group.",
      },
      {
        date: "Thu 25.06.26",
        title: "Diptych 01 — Book Launch",
        kind: "Launch",
        body: "Independent press Oblique House launches Diptych 01.",
      },
      {
        date: "Sat 04.07.26",
        title: "5TO9 Film Club Screening",
        kind: "Screening",
        body: "A film club screening in the Writers' Room.",
      },
      {
        date: "Fri 10.07.26",
        title: "Oral Methods — Reading Night",
        kind: "Reading",
        body: "Part of Esmé Hogeveen's events programme, Oral Methods.",
      },
      {
        date: "Tue 28.07.26",
        title: "Esmé Hogeveen — Film Screening",
        kind: "Screening",
        body: "A film screening curated by Esmé Hogeveen.",
      },
      {
        date: "Wed 29.07.26",
        title: "Reports from The Nose — Book Launch",
        kind: "Launch",
        body:
          "Independent press Lunchtime (Glasgow) launches Emma Aars' Reports from The Nose.",
      },
      {
        date: "July 2026",
        title: "VOICING — Choir Score & Performance",
        kind: "Performance · dates TBC",
        body: "A performance series across July. Dates to be confirmed.",
      },
      {
        date: "August 2026",
        title: "Donna Marcus & Raymond E. Slacker — Residency",
        kind: "Residency",
        body: "Donna Marcus and Raymond E. Slacker in residence.",
      },
      {
        date: "August — September 2026",
        title: "Donna's Writing School · Scratch Night · Performance",
        kind: "Programme · dates TBC",
        body:
          "A run of writing school sessions, a scratch night and a performance event. Dates to be confirmed.",
      },
      {
        date: "September — October 2026",
        title: "Lily Lavorato & Campbell McConnell — Residency",
        kind: "Residency · dates TBC",
        body:
          "Planned performances and a sculpture exhibition with readings. Dates to be confirmed.",
      },
    ],
  },
  {
    id: "sentient-projects",
    key: "04",
    title: "Sentient Projects",
    subtitle: "Dedicated to more immersive experiences.",
    tag: "Co-curated by Har-monic and The Florence Trust",
    intro:
      "Sentient Projects is an experiment: at a time when so much of life is mediated through screens, we offer an alternative, catering to the growing hunger for experiences that are unambiguously physical and real. The programme is dedicated to art, ritual, music, and collective gathering. A temple for everything that makes us human.",
    events: [
      {
        date: "01.06 — 23.06.26",
        title: "\"Look How Brightly\"",
        kind: "Interdisciplinary exhibition",
        body:
          "Curated by Jennifer Ellis (Apsara Studio) and Alex Mills. 'Look How Brightly' transforms composer Alex Mills' debut album into an interdisciplinary exhibition, reimagining the album launch as a site of encounter, contemplation and intimate exchange between contemporary music and art. The exhibition brings together work by 21 international artists that unpack the emotional and conceptual world of Mills' album — a retrospective spanning the last decade of the composer's output.",
      },
      {
        date: "07.06 & 21.06.26",
        title: "Sunday Spiritual Service",
        kind: "Ritual · hosted by Gayatri Anderson",
        body:
          "Satsang and Puja from the Hindu tradition, hosted by Gayatri Anderson, with the 'Look How Brightly' exhibition as the backdrop.",
      },
      {
        date: "01.07 — 14.07.26",
        title: "\"Opening Portals\" — Hiva Alizadeh",
        kind: "Solo exhibition · sponsored by the Florence Trust",
        body:
          "An exhibition of hanging sculptural pieces made of coloured hair, where portals are not destinations but thresholds — between different states of being, memory and perception.",
      },
      {
        date: "05.07.26",
        title: "Sunday Spiritual Service",
        kind: "Ritual · hosted by Gayatri Anderson",
        body:
          "Satsang and Puja from the Hindu tradition, hosted by Gayatri Anderson, with the 'Opening Portals' exhibition as the backdrop.",
      },
      {
        date: "12.07.26",
        title: "\"Tropicalia\" — Sunday Spiritual Service",
        kind: "Ritual · curated by P.l.a.y.ing",
        body:
          "In the Brazilian Orisha and Candomblé tradition, curated and hosted by P.l.a.y.ing, with the 'Opening Portals' exhibition as the backdrop.",
      },
      {
        date: "17.07.26",
        title: "RAW — Storytelling & Live Music",
        kind: "Storytelling · music · by What Does Not",
        body:
          "RAW started as one woman's obsession with strangers' stories. Part storytelling night, part human gathering, part something you won't have a word for until you've experienced it — London's original storytelling night. Something that touches you and transforms your perception.",
      },
      {
        date: "19.07.26",
        title: "Sunday Spiritual Service",
        kind: "Ritual · hosted by Gayatri Anderson",
        body:
          "Satsang and Puja from the Hindu tradition, hosted by Gayatri Anderson.",
      },
      {
        date: "24.07 — 01.08.26",
        title: "FT Artists in Residency — End of Year Show",
        kind: "Residency exhibition · Florence Trust",
        body:
          "Twelve international artists showing across the ground floor, rear and top floor spaces as a culmination to the residency programme.",
      },
      {
        date: "05.08 — 28.08.26",
        title: "To be announced",
        kind: "In development",
        body: "Programme details to follow.",
      },
      {
        date: "01.09 — 16.09.26",
        title: "\"How to build a Crystal Palace\" — Vattan Projects",
        kind: "Performance · collective gathering",
        body:
          "Artist Peyman Shafieezadeh, founder of the Iran-based artist-led platform and collective VATTAN_Projects, proposes a collective artist endeavour, performance and gathering.",
      },
      {
        date: "01.10 — 23.10.26",
        title: "\"The Soothsayer's Chorus\"",
        kind: "Exhibition · curated by Beth Greenacre and Bettina Prentice",
        body:
          "The exhibition reclaims Cassandra — the prophetess of Troy cursed to speak truth without being believed — as a collective, polyphonic figure. Rather than a lone voice doomed to isolation, Cassandra becomes many women speaking at once, across mediums. Prophecy is reimagined as inheritance — something passed from generation to generation. The exhibition focuses on female artists who explore intuition, collective ancestral memory and speculative futures.",
      },
      {
        date: "19.11 — 20.12.26",
        title: "CHAPTER FIVE / KAIHOGYO — The Waldorf Project",
        kind: "Immersive experience · created by Sean Hogg",
        body:
          "A radical immersive experience on a grand stage in which art is consumed through all of the senses. The experience unites the senses through physical movement, bespoke technology and sound, scent and environment design. From its genesis 14 years ago as a multi-sensory dining experience, the Waldorf Project has evolved into a daring experiment in consciousness transformation.",
      },
    ],
  },
];

export default function BritanniaEvents() {
  return (
    <div data-testid="britannia-events-page">
      {/* Hero */}
      <section className="hm-container pt-40 pb-20 md:pt-52 md:pb-24">
        <p className="hm-eyebrow mb-8">
          <Link
            to="/projects/35-britannia-row"
            className="hover:text-[color:var(--hm-ink)]"
            data-testid="events-breadcrumb"
          >
            ← Britannia Row
          </Link>
        </p>
        <h1
          className="font-display leading-[0.94] tracking-[-0.02em] max-w-5xl"
          style={{ fontSize: "clamp(48px, 7.2vw, 108px)", fontWeight: 400 }}
        >
          What&rsquo;s on at Britannia Row.
        </h1>
        <p className="mt-10 max-w-2xl text-[19px] text-[color:var(--hm-ink-dim)] leading-relaxed">
          A cultural programme running through 2026 across four strands, overseen by the Florence Trust. All events are free to attend and open to the public during opening hours unless otherwise stated. Learn more about the Florence Trust by clicking{" "}
          <a
            href="https://www.theflorencetrust.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hm-link"
            data-testid="events-florence-trust-link"
          >
            here
          </a>
          .
        </p>

        <div className="mt-14 flex flex-wrap gap-3 text-[13px]">
          {strands.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="hm-btn hm-btn-ghost"
              data-testid={`events-nav-${s.id}`}
            >
              <span className="text-[color:var(--hm-pink)] mr-3">{s.key}</span>
              {s.title}
            </a>
          ))}
        </div>
      </section>

      {/* Strands */}
      {strands.map((s) => (
        <section
          key={s.id}
          id={s.id}
          className="hm-container py-24 md:py-32 border-t border-[color:var(--hm-line)]"
          data-testid={`events-strand-${s.id}`}
        >
          <div className="grid md:grid-cols-12 gap-14 mb-16 md:mb-20">
            <div className="md:col-span-5">
              <p className="hm-eyebrow mb-6">
                <span className="text-[color:var(--hm-pink)] mr-3">{s.key}</span>
                {s.tag}
              </p>
              <h2
                className="font-display leading-[1.02] tracking-[-0.01em]"
                style={{ fontSize: "clamp(34px, 4.6vw, 64px)", fontWeight: 400 }}
              >
                {s.title}
              </h2>
              <p className="mt-6 text-[17px] text-[color:var(--hm-ink-dim)] leading-relaxed max-w-md">
                {s.subtitle}
              </p>
            </div>
            {s.intro && (
              <div className="md:col-span-7 md:pt-6">
                <p className="text-[16px] text-[color:var(--hm-ink-dim)] leading-relaxed">
                  {s.intro}
                </p>
              </div>
            )}
          </div>

          <ol className="border-t border-[color:var(--hm-line)]">
            {s.events.map((e, i) => (
              <li
                key={`${s.id}-${i}`}
                className="grid md:grid-cols-12 gap-8 md:gap-14 py-10 md:py-12 border-b border-[color:var(--hm-line)]"
                data-testid={`event-${s.id}-${i}`}
              >
                <div className="md:col-span-3">
                  <p
                    className="font-display text-[color:var(--hm-ink)] leading-none"
                    style={{ fontSize: "clamp(22px, 2vw, 28px)", fontWeight: 400 }}
                  >
                    {e.date}
                  </p>
                  <p className="hm-eyebrow mt-4 text-[color:var(--hm-pink)]">
                    {e.kind}
                  </p>
                </div>
                <div className="md:col-span-9">
                  <h3
                    className="font-display leading-[1.1] tracking-[-0.005em]"
                    style={{ fontSize: "clamp(22px, 2.4vw, 32px)", fontWeight: 400 }}
                  >
                    {e.title}
                  </h3>
                  {e.talk && (
                    <p className="mt-3 text-[14px] text-[color:var(--hm-pink)] tracking-[0.02em]">
                      {e.talk}
                    </p>
                  )}
                  <p className="mt-5 text-[16px] text-[color:var(--hm-ink-dim)] leading-relaxed max-w-3xl">
                    {e.body}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </section>
      ))}

      {/* Footnote / CTA */}
      <section className="hm-container py-28">
        <div className="border border-[color:var(--hm-line)] p-10 md:p-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <p className="hm-eyebrow mb-4">Visiting & press</p>
            <h3
              className="font-display max-w-2xl leading-[1.05]"
              style={{ fontSize: "clamp(24px, 3vw, 38px)", fontWeight: 400 }}
            >
              Programme details are updated as they&rsquo;re confirmed. For visits, group bookings or
              press, get in touch.
            </h3>
          </div>
          <Link
            to="/contact"
            className="hm-btn shrink-0"
            data-testid="events-cta-contact"
          >
            Get in touch →
          </Link>
        </div>
      </section>
    </div>
  );
}
